import React from 'react';
import './ProgressBar.css';

/**
 * ProgressBar
 * @param {number} value   - 0-100
 * @param {string} variant - '' | 'gold' | 'sky'
 */
export default function ProgressBar({ value = 0, variant = '' }) {
  return (
    <div className="progress-bar">
      <div
        className={`progress-bar__fill ${variant ? `progress-bar__fill--${variant}` : ''}`}
        style={{ width: `${Math.min(Math.max(value, 0), 100)}%` }}
      />
    </div>
  );
}
